<ng-container *ngIf="listData && listItemTemplate; else contentTemplate">
    <ng-container  *ngFor="let listItem of listData">
        <ng-container *ngTemplateOutlet="listItemTemplate; context: { $implicit: listItem }"></ng-container>
    </ng-container>
</ng-container>

<ng-template #contentTemplate>
    <ng-content></ng-content>
    <ng-content select="phx-list-item"></ng-content>
</ng-template>